import React, { useState } from "react";
import { connect } from "react-redux";
import { IonButton, IonCard, IonCardTitle, IonCol, IonContent, IonGrid, IonIcon, IonInput, IonItem, IonLabel, IonRouterLink, IonRow, IonText } from "@ionic/react";
import { checkmarkCircleOutline, closeCircleOutline } from "ionicons/icons";

import ApiRequestor from "../../api_access/ApiRequestor";
import { GetABMMenu } from "../../store/ABMMenu/ABMMenuActions";
import { GetKpiGroupsMenu } from "../../store/mainInfo/mainInfoActions";

import ToggleABMMenu from "./ToggleABMMenu";
import Modal from "../Modal/Modal";

import "./ABMMenu.css";

interface Props extends StateTypes, dispatchTypes {
    backToTable: () => void;
}

const AddABMMenu: React.FC<Props> = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [textModal, setTextModal] = useState('')
    const [menuInfoName, setMenuInfoName] = useState<string>("");
    const [menuInfoCategory, setMenuInfoCategory] = useState<string[]>(['']);
    const [menuInfoTitle, setMenuInfoTitle] = useState<string>("");
    const [menuInfoUrl, setMenuInfoUrl] = useState<string>("");
    const [errors, setErrors] = useState({ name: '', title: '', url: '', category: '' });
    const nameRegex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\/]+(\s[a-zA-ZáéíóúÁÉÍÓÚñÑ\/]+)*$/;
    const regularExpressionURL = /^(?!\/)(?!.*\/\/)([A-Za-z-]+(\/[A-Za-z-]+)*)$/;

    const menuInfo = {
        menuinfo_name: menuInfoName,
        menuinfo_title: menuInfoTitle,
        menuinfo_url: menuInfoUrl,
        menuinfo_category: menuInfoCategory,
    };

    const validationForm = () => {
        const isEmpty = (value: any) => {
            if (Array.isArray(value)) return value.length === 0 || value.every(item => item.trim() === "");
            if (typeof value === "string") return value.trim() === "";
            return !value;
        };
        const isInvalidText = (value: any) => !nameRegex.test(value);
        const isInvalidURL = (value: any) => !regularExpressionURL.test(value);

        const errors = {
            name: isEmpty(menuInfo.menuinfo_name)
                ? 'Se debe seleccionar un ícono.'
                : '',
            title: isEmpty(menuInfo.menuinfo_title)
                ? 'El campo no debe estar vacío.'
                : isInvalidText(menuInfo.menuinfo_title) || menuInfo.menuinfo_title.length >= 30
                    ? 'Solo letras y espacios intermedios. Máximo 30 carácteres.'
                    : '',
            url: isEmpty(menuInfo.menuinfo_url)
                ? 'El campo no debe estar vacío.'
                : isInvalidURL(menuInfo.menuinfo_url) || menuInfo.menuinfo_url.length >= 30
                    ? 'Solo letras, / y -. Máximo 30 carácteres.'
                    : '',
            category: isEmpty(menuInfo.menuinfo_category)
                ? 'Se debe seleccionar por lo menos una categoría.'
                : ''
        };

        setErrors(errors as any);
        const hasErrors = Object.values(errors).some(error => error !== '');

        return hasErrors;
    }

    const createItemMenu = async (e: any) => {
        e.preventDefault();
        validationForm();

        let valid = validationForm();

        if (!valid) {
            let data: any = {
                body: {
                    "menuinfo_name": menuInfoName,
                    "menuinfo_title": menuInfoTitle,
                    "menuinfo_url": `/page/${menuInfoUrl}`,
                    "menuinfo_category": menuInfoCategory,
                }
            }

            const response: any = await ApiRequestor.requestToApi("/swt-admin/menu-info", "POST", data);

            if (response && response.status === 200) {
                setTextModal('Item Menú Creado Correctamente')
                props.getABMMenu();
                props.getMenuInfo();
                setShowModal(true);
            } else {
                if (response && response.includes("status code 500")) {
                    setTextModal('No se pudo crear el usuario. Por favor chequear los datos ingresados')
                    setShowModal(true)
                }
            }
        } else {
            validationForm()
        }
    }

    const dismissModal = () => {
        props.backToTable();
    }

    return (
        <div className="custom-content-scroll">
            <IonCard className="abmmenu-card-add">
                <IonCardTitle className="abmmenu-title-add">
                    ALTA DE ITEM MENÚ
                </IonCardTitle>
                <IonGrid className="abmmenu-grid-add">
                    <IonRow>
                        <IonCol sizeXl="6" sizeXs="12">
                            <IonLabel className="abmmenu-label-add">Nombre</IonLabel>
                            <IonItem className="abmmenu-item-add" lines="none">
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el nombre de la pestaña"
                                    className="abmmenu-imput-add"
                                    value={menuInfoTitle}
                                    onIonChange={(e) => setMenuInfoTitle(e.detail.value!)}
                                />
                            </IonItem>
                            <IonText>
                                <p className={errors.title ? "abmmenu-valid-text" : "ion-hide"}>{errors.title}</p>
                            </IonText>
                        </IonCol>
                        <IonCol sizeXl="6" sizeXs="12">
                            <IonLabel className="abmmenu-label-add">URL</IonLabel>
                            <IonItem className="abmmenu-item-add" lines="none">
                                <IonLabel>/page/</IonLabel>
                                <IonInput
                                    type="text"
                                    placeholder="Ingrese el URL"
                                    className="abmmenu-imput-add"
                                    value={menuInfoUrl}
                                    onIonChange={(e) => setMenuInfoUrl(e.detail.value ?? "")}
                                />
                            </IonItem>
                            <IonText>
                                <p className={errors.url ? "abmmenu-valid-text" : "ion-hide"}>{errors.url}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size="12">
                            <IonLabel className="abmmenu-label-add">Categoría</IonLabel>
                            <ToggleABMMenu
                                options={'categoria'}
                                onSelectionChange={(selected) => setMenuInfoCategory(selected)}
                            />
                            <IonText>
                                <p className={errors.category ? "abmmenu-valid-text" : "ion-hide"}>{errors.category}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow>
                        <IonCol size="12">
                            <IonLabel className="abmmenu-label-add">Ícono</IonLabel>
                            <ToggleABMMenu
                                onIconSelect={(iconName) => setMenuInfoName(iconName)}
                            />
                            <IonText>
                                <p className={errors.name ? "abmmenu-valid-text" : "ion-hide"}>{errors.name}</p>
                            </IonText>
                        </IonCol>
                    </IonRow>

                    <IonRow className="abmmenu-boton-container">
                        <IonButton type="submit" fill="clear" onClick={createItemMenu}>
                            <IonIcon icon={checkmarkCircleOutline} color="success" className=" abmmenu-boton-icon" />
                        </IonButton>
                        <IonRouterLink href='/page/menu-info'>
                            <IonButton fill="clear" onClick={props.backToTable}>
                                <IonIcon icon={closeCircleOutline} color="danger" className="abmmenu-boton-icon" />
                            </IonButton>
                        </IonRouterLink>
                    </IonRow>
                </IonGrid>
            </IonCard>

            <Modal
                modalConfirmation={
                    {
                        textConfirmation: textModal,
                        onDidDimissConfirmModal: () => dismissModal(),
                        isOpenModalConfirm: showModal,
                        onClickConfirmModal: () => dismissModal()
                    }
                }
            />
        </div>
    );
};

interface StateTypes {

}

const mapStatetoProps = (state: StateTypes) => ({

});

interface dispatchTypes {
    getABMMenu: () => void;
    getMenuInfo: () => void
}
const mapDispatchToProps = (dispatch: any) => ({
    getABMMenu: () => dispatch(GetABMMenu()),
    getMenuInfo: () => dispatch(GetKpiGroupsMenu()),
});

export default connect(mapStatetoProps, mapDispatchToProps)(AddABMMenu);
